import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Row} from "mdbreact";
import {Link} from "react-router-dom";
import {API_URL} from "../../config/Config";
import axios from "axios/index";
import axiosRetry from 'axios-retry';
import PageLoader from "../../components/loader/PageLoader";
import Merchant2 from "../../components/merchants/Merchant2";
axiosRetry(axios, { retries: 3 });


export default class MerchantListByCat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            merchants:[],
            category:{},
            loading:false,
            notFound:''
        };
    }
    async componentDidMount(){
        const { params } = await this.props.match;
        const cat_id = await params.id;
        await this.getMerchantList(cat_id);
    }
    async getMerchantList(id) {
        try {
            let response = await axios.get(`${API_URL}merchant-by-category/${id}`);
            let category = await response.data.data;
            let merchants = await response.data.data.merchants;
            this.setState({category,merchants});
        }catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                console.log(statusText);
                if (apiError.status === 404){
                    this.setState({
                        notFound:'دسته بندی نا مشخص'
                    })
                }
            }
        }
        this.setState({loading: true});
    }


    render() {
        return (
            <div >
                <div className="jumbotron text-center rtl">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <h1 className="pag-title">
                                {this.state.notFound === ''?`${this.state.category.name}`:`${this.state.notFound}`}
                            </h1>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                                <BreadcrumbItem ><Link to="/merchantList" >مراکز طرف قرارداد</Link></BreadcrumbItem>
                                <BreadcrumbItem active>{this.state.notFound === ''?`${this.state.category.name}`:`${this.state.notFound}`}</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container rtl" style={{minHeight:500}}>
                    {!this.state.loading? <PageLoader type="spinningBubbles" color="#f6581d" />:
                        <Row>
                             {this.state.merchants.length===0?<p className="w-100 text-center">موردی یافت نشد</p>:``}

                            {this.state.merchants.map( merchant =>
                                <Merchant2 key={merchant.id} merchantObj={merchant}/>
                            )}

                        </Row>}
                </div>


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/merchants/MerchantListByCat.js